var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNaverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 1.5625C2.1403 1.5625 1.95923 1.63981 1.80054 1.79443C1.64185 1.94906 1.5625 2.13216 1.5625 2.34375V22.6562C1.5625 22.8678 1.64185 23.0509 1.80054 23.2056C1.95923 23.3602 2.1403 23.4375 2.34375 23.4375H22.6562C22.8597 23.4375 23.0408 23.3602 23.1995 23.2056C23.3582 23.0509 23.4375 22.8678 23.4375 22.6562V2.34375C23.4375 2.13216 23.3582 1.94906 23.1995 1.79443C23.0408 1.63981 22.8597 1.5625 22.6562 1.5625H2.34375ZM6.45752 7.03125H10.6689L14.3311 12.5V7.03125H18.5425V17.9688H14.3311L10.6689 12.5V17.9688H6.45752V7.03125Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverIcon);
export default __webpack_public_path__ + "static/media/naver_icon.ab6971e5565e3f5a37bd8f1f0b7dcdf0.svg";
export { ForwardRef as ReactComponent };